import { EMPLOYEE_COMPETENCY_LEVEL } from 'domain/shared/performanceMeasurement';
import { type FilterState } from 'framework/ViewTypes/components';
import { FilterCondition } from 'framework/types';
import type { CollectionViewParamsConfig } from 'framework/ViewTypes';
import { POSITION_SLOT_LIFECYCLE, POSITION_SLOT_WORKER_TYPE } from '../constants';

export const POSITION_SLOTS_STATE_VALIDATION: Pick<
  CollectionViewParamsConfig<FilterState>,
  'filterRules' | 'sortableColumns'
> = {
  filterRules: {
    specializationId: { condition: FilterCondition.IN },
    technologyId: { condition: FilterCondition.IN },
    businessFunctionId: { condition: FilterCondition.IN },
    competencyLevel: { condition: FilterCondition.IN, values: Object.keys(EMPLOYEE_COMPETENCY_LEVEL) },
    lifecycle: { condition: FilterCondition.IN, values: Object.values(POSITION_SLOT_LIFECYCLE) },
    workerType: { condition: FilterCondition.IN, values: Object.values(POSITION_SLOT_WORKER_TYPE) },
    officeIds: { condition: FilterCondition.IN },
  },
  sortableColumns: [
    'createdAt',
    'specialization',
    'technology',
    'competencyLevel',
    'workRateType',
    'workerType',
    'offices',
    'lifecycle',
  ],
};
